import { render, staticRenderFns } from "./CoteacherDialog.vue?vue&type=template&id=67f4bd2c"
import script from "./CoteacherDialog.vue?vue&type=script&lang=js"
export * from "./CoteacherDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports